import { render, staticRenderFns } from "./PageInDevelopment.vue?vue&type=template&id=6cbb7e51&scoped=true&"
import script from "./PageInDevelopment.vue?vue&type=script&lang=js&"
export * from "./PageInDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./PageInDevelopment.vue?vue&type=style&index=0&id=6cbb7e51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbb7e51",
  null
  
)

export default component.exports